var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"width":"100%"}},[_vm._t("default",function(){return [_c('v-btn',{staticStyle:{"color":"#EC4DA3","border":"1px solid #EC4DA3"},attrs:{"color":"accent-4","text":""},on:{"click":_vm.onClick}},[_vm._v(" "+_vm._s(_vm._f("translate")('취소'))+" ")])]},null,{ on: _vm.on })],2)
}
var staticRenderFns = []

export { render, staticRenderFns }